'use strict';

angular.module('atex.art').directive('formSubmit', ['$rootScope', function($rootScope) {
  return {
    scope: true,
    link: function(scope, elem, attrs) {
      elem.on('keypress', 'input[type!="submit"]', function(e) {
        $rootScope.$apply(function() {
          if (e.keyCode === 13) { // Call the submit callback if 'Enter'
            scope[attrs.callback]();
            e.preventDefault();
          }
        });
      });
    }
  };
}]);
